import api from 'utils/api';
export const saveAutoReloadPreference = async (businessId, reloadAmount) => {
  if (!businessId) {
    throw new Error('A business is required to update automatic reload.');
  }
  if (reloadAmount === null || reloadAmount === undefined) {
    throw new Error('A valid automatic reload amount is required.');
  }

  await api.put(`/business/${businessId}/reload/${reloadAmount}`);
  return { amount: reloadAmount, enabled: reloadAmount > 0 };
};
